import ViewLoginActivities from "../components/LoginActivity/ViewLoginActivities";

const LoginActivityPage: React.FC = () => {
  return <ViewLoginActivities />;
};

export default LoginActivityPage;
